import { gql } from "@apollo/client"

export const STORE_LIST = gql`
  query StoreList($StoreListInput: StoreListInput!) {
    StoreList(input: $StoreListInput) {
      status {
        success
        name
        detail
      }
      total
      pages
      Stores {
        id
        name
        description
        logo
        urlLogo
        cover
        urlCover
        phone
        email
        urlView
        urlTournaments
        siteUrl
        inChargePerson
        active
        levelId
        Level {
          id
          name
          icon
        }
        StoreTournamentTypes {
          id
          storeId
          typeId
          quantity
        }
        StoreGames {
          id
          gameId
          storeId
          Game {
            name
          }
        }

        StoreTournamentDays {
          TournamentDay {
            id
            name
          }
        }
        Address {
          id
          name
          address
          countryId
          regionId
          locationId
          Location {
            name
          }
        }
      }
    }
  }
`
